import {html} from 'lit-html';
import {repeat} from 'lit-html/directives/repeat';
import {formatMoney} from '../money';
import {ThemeCurrency} from '../const';
import Translate from '../translate';
import {classMap} from 'lit-html/directives/class-map';

// Function to toggle bundle items visibility
const toggleBundleItems = (e) => {
  const bundleLayout = e.currentTarget.closest('[data-bundle-collpase]');
  bundleLayout.classList.toggle('cl-bundle-cart-collapsed');
};

/**
 * Render Bundle layout on cart item
 *
 * @returns {TemplateResult}
 */
const template = (item, bundleProducts, total, open = false) => html`
    <div class="cl-bundle-cart-layout ${classMap({'cl-bundle-cart-collapsed': !open})}" data-bundle-collpase>
        <div class="cl-bundle-cart-title" @click=${toggleBundleItems}>
            <span class="cl-bundle-cart-show">${Translate.get('product.options.bundle.show', {}, 'Show')} ${total} ${Translate.get('product.options.bundle.items', {}, 'items')} <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14"><path stroke-linecap="round" stroke-linejoin="round" d="M12 4.75 7.354 9.396a.5.5 0 0 1-.708 0L2 4.75"></path></svg></span>
            <span class="cl-bundle-cart-hide">${Translate.get('product.options.bundle.hide', {}, 'Hide')} ${total} ${Translate.get('product.options.bundle.items', {}, 'items')} <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14"><path stroke-linecap="round" stroke-linejoin="round" d="m2 9.25 4.646-4.646a.5.5 0 0 1 .708 0L12 9.25"></path></svg></path></svg></span>
        </div>
        <div class="cl-bundle-cart-items-collapse">
            <div class="cl-bundle-cart-items">
            ${repeat(bundleProducts, (bundleProduct) => html`
                <div class="cl-bundle-cart-item">
                    <div class="cl-bundle-item__wrapper">
                        <img class="cl-bundle-item__image" src="${bundleProduct.img}" alt="${bundleProduct.title}">
                        <a href="${bundleProduct.url}" class="cl-bundle-item__title">
                            <span class="cl-bundle-item__quantity">${bundleProduct.quantity * item.quantity}x</span>
                            ${bundleProduct.title}
                        </a>
                    </div>
                    <div class="cl-bundle-price cl-bundle-item-price">
                        <span class="cl-bundle-price__current">${bundleProduct.price > 0 ? formatMoney((bundleProduct.price * 100) * (bundleProduct.quantity * item.quantity), ThemeCurrency.moneyFormat) : Translate.get('product.options.free', {}, 'FREE')}</span>
                        ${bundleProduct.priceBefore !== bundleProduct.price ? html`
                            <span class="cl-bundle-price__before">${formatMoney((bundleProduct.priceBefore * 100) * (bundleProduct.quantity * item.quantity), ThemeCurrency.moneyFormat)}</span>
                        ` : ''}
                    </div>
                </div>`
            )}
            </div>
        </div>
    </div>
`;

export default template;
